import {
    LoginState,
    initialLoginState,
    initialLoginStateSentinel,
} from "@/mk2/apps/users/containers/Login/Login.reducers";
import { AppState } from "@/mk2/reducers";

export const getLoginState = (state: AppState, contentItemsKey: string): LoginState =>
    !contentItemsKey
        ? initialLoginStateSentinel
        : state.containers.users.logins[contentItemsKey] || initialLoginState;
